import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { SecretStorePage } from '@/features/admin/secret-store/secret-store-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Coffre des secrets du locataire (ADR 0095) — `GET|PUT|DELETE /secret-store`, `…/check`, `…/migrate` (`/tenant/admin`). */
export const Route = createFileRoute('/$tenant/secret-store')({ component: SecretStoreRoute });

function SecretStoreRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} activeItem="secretStore" crumbs={[{ label: t('secretStore.title') }]}>
      <SecretStorePage tenantId={tenant} />
    </ConsoleShell>
  );
}
